import type {ReactElement} from 'react';
import React from 'react';
import {AddButton} from '@Components/add-button';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {openPosterAddItemsModal} from '@Modals/poster-add-items-modal';
import {Text, TextSize} from '@Components/text';
import styles from './poster-editor-add-item-button.module.scss';

interface PosterEditorAddItemButtonProps {
  showSkeletonState?: boolean;
}

export function PosterEditorAddItemButton({showSkeletonState = false}: PosterEditorAddItemButtonProps): ReactElement<any> {
  const onClickHandler = (): void => {
    openPosterAddItemsModal({});
  };

  const getSkeleton = (): ReactElement<any> => {
    return <SkeletonBrick theme={SkeletonBrickTheme.LIGHT_TWO} width={48} height={48} radius="100px" />;
  };

  const getAddButton = (): ReactElement<any> => {
    return (
      <div className={styles.addButton}>
        <div className={styles.wrapperContainer}>
          {showSkeletonState ? (
            getSkeleton()
          ) : (
            <>
              <div className={`flex-center _full-width ${styles.borderRight}`}>
                <AddButton onClick={onClickHandler} />
              </div>
              <Text className={styles.addText} val="Add" size={TextSize.XXSMALL} />
            </>
          )}
        </div>
      </div>
    );
  };
  return getAddButton();
}
